import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import Layout from '../../Components/Layout'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import GoogleMapsLoader from '../../Components/Autocomplete/GoogleMapsLoader';
import Select from "react-dropdown-select";
import ReactDOM from 'react-dom';
import config from '../../config';
import { FaMapMarkerAlt, FaHotel, FaBed } from "react-icons/fa";
import { MdOutlineLocalAirport } from "react-icons/md";
import ListCard from '../../Components/Hotel/ListCard';
import { Modal, Button } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";
import Swal from 'sweetalert2'
import { fetchMarkup, getPrice } from '../../services/priceUtils';
import hotelService from '../../services/hotelService';
import { calculateDistance, getSimilarityScore, findHotelsByDistanceAndSimilarity } from '../../services/hotelUtils';

export default function GridList() {
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();
    const counterRef = useRef(null);
    const debounceTimeout = useRef(null);
    const { occupancies, start_date, end_date } = location.state || {};

    // Form state'leri
    const [formParams, setFormParams] = useState({
        locationName: searchParams.get('locationName'),
        checkIn: searchParams.get('checkIn'),
        checkOut: searchParams.get('checkOut'),
        nation: searchParams.get('nation'),
        lat: searchParams.get('lat'),
        lng: searchParams.get('lng'),
        occupanciesStr: searchParams.get('occupancies'),
        rooms: (() => {
            try {
                const occupanciesStr = searchParams.get('occupancies');
                if (occupanciesStr) {
                    const decodedStr = decodeURIComponent(occupanciesStr);
                    const parsed = JSON.parse(decodedStr);
                    if (Array.isArray(parsed)) {
                        return parsed.map((room, index) => ({
                            id: index + 1,
                            adultCounter: room.adults || 2,
                            childCounter: room.children || 0,
                            childrenAges: room.paxes?.filter(pax => pax.type === "CH").map(child => ({
                                type: 'CH',
                                age: child.age || 0
                            })) || []
                        }));
                    }
                }
            } catch (error) {
                console.error('Error parsing occupancies:', error);
            }
            return [{
                id: 1,
                adultCounter: 2,
                childCounter: 0,
                childrenAges: []
            }];
        })()
    });

    // Otel verilerini tutacak state'ler
    const [hotelCodes, setHotelCodes] = useState([]);
    const [sortedHotels, setSortedHotels] = useState([]);
    const [detailedHotels, setDetailedHotels] = useState([]);
    const [firstHotel, setFirstHotel] = useState(null);
    const [loadedHotels, setLoadedHotels] = useState([]);
    const [moreStatu, setMoreStatu] = useState(false);
    const [moreButtonStatu, setMoreButtonStatu] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingHotels, setLoadingHotels] = useState({});
    const [moreCounter, setMoreCounter] = useState(0);
    const step = 10;

    // UI state'leri
    const [suggestions, setSuggestions] = useState([]);
    const [isSuggestLoading, setIsSuggestLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [selectedOption, setSelectedOption] = useState('recommend');
    const [isFixed, setIsFixed] = useState(false);
    const [height, setHeight] = useState('90%');
    const [personalModal, setPersonalModal] = useState(false);
    const [countries, setCountries] = useState([]);
    const [selectedRate, setSelectedRate] = useState(null);
    const [markupValue, setMarkupValue] = useState(0);
    const [selectedLocation, setSelectedLocation] = useState({
        name: location.state?.selectedLocation?.name ?? null,
        latitude: location.state?.selectedLocation?.latitude ?? null,
        longitude: location.state?.selectedLocation?.longitude ?? null,
        hotelbeds_code: location.state?.selectedLocation?.hotelbeds_code ?? null,
        formatted_address: location.state?.selectedLocation?.formatted_address ?? null,
    });
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [error, setError] = useState(null);
    const userData = JSON.parse(localStorage.getItem('user_data'));

    // Harita için state'ler
    const [isMapLoaded, setIsMapLoaded] = useState(false);
    const apiKey = config.API_KEY;

    // useMemo ile otel fetch parametrelerini optimize et
    const hotelFetchParams = useMemo(() => {
        const rooms = formParams?.rooms || [{
            id: 1,
                        adultCounter: 2,
                        childCounter: 0,
            childrenAges: []
        }];

        const roomsArray = Array.isArray(rooms) ? rooms : [rooms];
        const firstRoom = roomsArray[0];

        let occupanciesData;
        try {
            if (searchParams.get('occupancies')) {
                const decodedOccupancies = JSON.parse(decodeURIComponent(searchParams.get('occupancies')));
                occupanciesData = decodedOccupancies;
            }
        } catch (error) {
            console.error('Error parsing occupancies:', error);
        }

        return {
            stay: {
                checkIn: formParams.checkIn,
                checkOut: formParams.checkOut
            },
            geolocation: {
                latitude: formParams.lat,
                longitude: formParams.lng,
                radius: 3,
                unit: "km"
            },
            language: "ENG",
            sourceMarket: formParams.nation ?? "ENG",
            occupancies: occupanciesData || [{
                rooms: firstRoom?.id || 1,
                adults: firstRoom?.adultCounter || 2,
                children: firstRoom?.childCounter || 0,
                paxes: firstRoom?.childrenAges?.map(child => ({
                                type: "CH",
                    age: child.age === "" ? 0 : Number(child.age)
                            })) || []
            }],
            filters: {
                minPrice: 100,
                maxPrice: 5000,
                maxRooms: 10,
                maxRatesPerRoom: 5
            }
        };
    }, [formParams?.checkIn, formParams?.checkOut, formParams?.lat, formParams?.lng, formParams?.nation, formParams?.rooms, searchParams]);

    // Small data'yı yüklemek için fonksiyon
    const loadSmallData = useCallback(async (code, index) => {
        if (!code || loadingHotels[code]) return;
        
        if (loadedHotels.includes(code)) {
            console.log(`Otel ${code} zaten yüklenmiş, tekrar yükleme yapılmıyor.`);
                    return;
                }

        try {
            setLoadingHotels(prev => ({ ...prev, [code]: true }));
            console.log(`Small-data yükleniyor: ${code}`);

            const occupanciesData = (() => {
                try {
                    if (searchParams.get('occupancies')) {
                        const decodedOccupancies = JSON.parse(decodeURIComponent(searchParams.get('occupancies')));
                        return decodedOccupancies;
                    }
                } catch (error) {
                    console.error('Error parsing occupancies:', error);
                }
                return [{
                    rooms: 1,
                    adults: formParams.rooms[0].adultCounter || 2,
                    children: formParams.rooms[0].childCounter || 0,
                    paxes: formParams.rooms[0].childrenAges?.map(child => ({
                        type: "CH",
                        age: child.age === "" ? 0 : Number(child.age)
                    })) || []
                }];
            })();

            const requestParams = {
                stay: {
                    checkIn: formParams.checkIn,
                    checkOut: formParams.checkOut
                },
                occupancies: occupanciesData,
                language: "ENG",
                sourceMarket: formParams.nation ?? "ENG"
            };

            const smallData = await hotelService.getSmallData([code], requestParams);
            console.log(`Small-data yanıtı alındı: ${code}`, smallData);
            
            if (smallData && smallData.length > 0) {
                const hotelData = smallData[0];
                
                if (!hotelData.rooms || hotelData.rooms.length === 0) {
                    console.warn(`Otel ${code} için oda bilgisi bulunamadı`);
                    const originalHotel = sortedHotels.find(h => h.code === code);
                    if (originalHotel && originalHotel.rooms) {
                        hotelData.rooms = originalHotel.rooms;
                    }
                } else {
                    console.log(`Otel ${code} için small-data'dan oda bilgisi alındı, ancak ilk API'den gelen odaları da koruyoruz.`);
                    const originalHotel = sortedHotels.find(h => h.code === code);
                    if (originalHotel && originalHotel.rooms) {
                        hotelData.rooms = originalHotel.rooms;
                    }
                }
                
                setLoadedHotels(prev => {
                    if (prev.includes(code)) return prev;
                    return [...prev, code];
                });
                
                if (firstHotel && firstHotel[0] && firstHotel[0].code === code) {
                    setFirstHotel(prevFirstHotel => {
                        if (!prevFirstHotel || !prevFirstHotel[0]) return prevFirstHotel;
                        
                        if (JSON.stringify(prevFirstHotel[0]) === JSON.stringify({...prevFirstHotel[0], ...hotelData})) {
                            return prevFirstHotel;
                        }
                        
                        const updatedFirstHotel = [...prevFirstHotel];
                        updatedFirstHotel[0] = {
                            ...updatedFirstHotel[0],
                            ...hotelData,
                            rooms: hotelData.rooms || updatedFirstHotel[0].rooms || [],
                            minRate: hotelData.minRate || updatedFirstHotel[0].minRate || 0,
                            images: hotelData.images || [],
                            description: hotelData.description || "",
                            categoryCode: hotelData.categoryCode || updatedFirstHotel[0].categoryCode || [],
                            city: hotelData.city || {},
                            country: hotelData.country || {},
                            segments: hotelData.segments || []
                        };
                        
                        console.log("İlk otel güncellendi:", updatedFirstHotel[0]);
                        return updatedFirstHotel;
                    });
                }
                
                setDetailedHotels(prevHotels => {
                    const hotelIndex = prevHotels.findIndex(h => h.code === code);
                    
                    if (hotelIndex !== -1) {
                        if (JSON.stringify(prevHotels[hotelIndex]) === JSON.stringify({...prevHotels[hotelIndex], ...hotelData})) {
                            return prevHotels;
                        }
                        
                        const updatedHotels = [...prevHotels];
                        updatedHotels[hotelIndex] = {
                            ...updatedHotels[hotelIndex],
                            ...hotelData,
                            rooms: hotelData.rooms || updatedHotels[hotelIndex].rooms || [],
                            minRate: hotelData.minRate || updatedHotels[hotelIndex].minRate || 0,
                            images: hotelData.images || [],
                            description: hotelData.description || "",
                            categoryCode: hotelData.categoryCode || updatedHotels[hotelIndex].categoryCode || [],
                            city: hotelData.city || {},
                            country: hotelData.country || {},
                            segments: hotelData.segments || []
                        };
                        console.log(`Otel güncellendi (${code}):`, updatedHotels[hotelIndex]);
                        return updatedHotels;
                    } else {
                        const originalHotel = sortedHotels.find(h => h.code === code);
                        if (!originalHotel) {
                            console.warn(`Otel kodu ${code} için orijinal veri bulunamadı`);
                            return prevHotels;
                        }
                        
                        const newHotel = {
                            ...originalHotel,
                            ...hotelData,
                            rooms: hotelData.rooms || originalHotel.rooms || [],
                            minRate: hotelData.minRate || originalHotel.minRate || 0,
                            images: hotelData.images || [],
                            description: hotelData.description || "",
                            categoryCode: hotelData.categoryCode || originalHotel.categoryCode || [],
                            city: hotelData.city || {},
                            country: hotelData.country || {},
                            segments: hotelData.segments || []
                        };
                        
                        const allHotels = [...prevHotels];
                        allHotels.push(newHotel);
                        
                        const sortedDetailedHotels = [];
                        
                        if (firstHotel && firstHotel[0]) {
                            const firstHotelInDetailed = allHotels.find(h => h.code === firstHotel[0].code);
                            if (firstHotelInDetailed) {
                                sortedDetailedHotels.push(firstHotelInDetailed);
                            }
                        }
                        
                        for (const hotelCode of hotelCodes) {
                            if (firstHotel && firstHotel[0] && hotelCode === firstHotel[0].code) {
                                continue;
                            }
                            
                            const hotelInDetailed = allHotels.find(h => h.code === hotelCode);
                            if (hotelInDetailed) {
                                sortedDetailedHotels.push(hotelInDetailed);
                            }
                        }
                        
                        console.log(`Yeni otel eklendi (${code}) ve liste sıralandı.`);
                        return sortedDetailedHotels;
                    }
                });
            } else {
                console.warn(`Small-data API'si ${code} için veri döndürmedi`);
            }
        } catch (error) {
            console.error(`Error loading small data for hotel ${code}:`, error);
        } finally {
            setLoadingHotels(prev => ({ ...prev, [code]: false }));
        }
    }, [formParams.nation, sortedHotels, firstHotel, loadingHotels, detailedHotels, loadedHotels, hotelCodes, formParams.checkIn, formParams.checkOut, formParams.rooms, searchParams]);

    // Otel kodları değiştiğinde small data'yı yükle
    useEffect(() => {
        if (hotelCodes.length === 0 || isLoading) return;
        
        const alreadyLoadedCodes = new Set(loadedHotels);
        
        const loadHotelsSequentially = async () => {
            const codesToLoad = hotelCodes.slice(0, 10).filter(code => !alreadyLoadedCodes.has(code) && !loadingHotels[code]);
            
            if (codesToLoad.length === 0) return;
            
            if (firstHotel && firstHotel[0] && codesToLoad.includes(firstHotel[0].code)) {
                await loadSmallData(firstHotel[0].code, 0);
                const firstHotelIndex = codesToLoad.indexOf(firstHotel[0].code);
                if (firstHotelIndex !== -1) {
                    codesToLoad.splice(firstHotelIndex, 1);
                }
            }
            
            for (const code of hotelCodes.slice(0, 10)) {
                if (firstHotel && firstHotel[0] && code === firstHotel[0].code) {
                    continue;
                }
                
                if (!codesToLoad.includes(code)) {
                    continue;
                }
                
                await loadSmallData(code);
                await new Promise(resolve => setTimeout(resolve, 100));
            }
        };
        
        loadHotelsSequentially();
    }, [hotelCodes, loadSmallData, firstHotel, loadedHotels, isLoading, loadingHotels]);

    // Otelleri seçilen seçeneğe göre sıralayan fonksiyon
    const sortHotelsByOption = (hotelData, sortOption) => {
        if (!hotelData || hotelData.length === 0) return [];
        
        switch (sortOption) {
            case 'price_asc':
                return [...hotelData].sort((a, b) => parseFloat(a.minRate || 0) - parseFloat(b.minRate || 0));
            case 'price_desc':
                return [...hotelData].sort((a, b) => parseFloat(b.minRate || 0) - parseFloat(a.minRate || 0));
            case 'name_asc':
                return [...hotelData].sort((a, b) => (a.name || "").localeCompare(b.name || ""));
            case 'name_desc':
                return [...hotelData].sort((a, b) => (b.name || "").localeCompare(a.name || ""));
            case 'recommend':
            default:
                return hotelData;
        }
    };

    const fetchHotels = async (requestData) => {
        if (isLoading) return;
        
        setIsLoading(true);
        const resetStates = () => {
            setDetailedHotels([]);
            setFirstHotel(null);
            setHotelCodes([]);
            setSortedHotels([]);
            setLoadingHotels({});
            setLoadedHotels([]);
            setMoreButtonStatu(false);
            setMoreStatu(false);
            setMoreCounter(0);
        };
        
        resetStates();
        
        try {
            const hotels = await hotelService.getHotels(requestData);
            
            if (hotels && hotels.length > 0) {
                let sortedHotelsArray = hotels;
                
                if (requestData.geolocation?.latitude && requestData.geolocation?.longitude) {
                    sortedHotelsArray = findHotelsByDistanceAndSimilarity(
                        parseFloat(requestData.geolocation.latitude),
                        parseFloat(requestData.geolocation.longitude),
                        hotels,
                        formParams.locationName
                    );
                }
                
                if (requestData.filter?.sort) {
                    sortedHotelsArray = sortHotelsByOption(sortedHotelsArray, requestData.filter.sort);
                }
                
                setSortedHotels(sortedHotelsArray);
                setHotelCodes(sortedHotelsArray.map(hotel => hotel.code));
                setMoreButtonStatu(sortedHotelsArray.length > 10);
                setMoreCounter(0);

                // Sadece ilk 10 otel için small-data çek
                const firstTenHotels = sortedHotelsArray.slice(0, 10);
                for (const hotel of firstTenHotels) {
                    await loadSmallData(hotel.code);
                }
            } else {
                resetStates();
            }
        } catch (error) {
            console.error("Error fetching hotels:", error);
            resetStates();
        } finally {
            setIsLoading(false);
        }
    };

    const handleViewDetails = async (hotel) => {
        if (!formParams.rooms || !Array.isArray(formParams.rooms)) {
            console.error('Invalid rooms data');
            return;
        }

        const currentOccupancies = formParams.rooms.map(room => ({
            rooms: 1,
            adults: room.adultCounter,
            children: room.childCounter,
            paxes: room.childrenAges?.map(child => ({
                type: "CH",
                age: child.age || 0
            })) || []
        }));

        const params = new URLSearchParams({
            code: hotel.code,
            slug: hotel.slug,
            checkIn: formParams.checkIn,
            checkOut: formParams.checkOut,
            rooms: currentOccupancies.map(occ => occ.rooms).join(','),
            adults: currentOccupancies.map(occ => occ.adults).join(','),
            children: currentOccupancies.map(occ => occ.children).join(','),
            ages: currentOccupancies.map(occ => occ.paxes.map(p => p.age).join('-')).join('|'),
            nationality: localStorage.getItem("nation") || 'TR'
        });

        navigate(`/hotel-detail?${params.toString()}`);
        window.scrollTo(0, 0);
    };

    const handleBookSubmit = async (rate, hotel, room) => {
        try {
            if (!userData?.token) {
                Swal.fire({
                    title: "Please login first!",
                    icon: "error",
                    draggable: true,
                });
                return;
            }

            const rateDates = rate.rateKey.split('|');
            const rateCheckIn = rateDates[0].replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
            const rateCheckOut = rateDates[1].replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');

            const storedCheckIn = localStorage.getItem('start_date');
            const storedCheckOut = localStorage.getItem('end_date');

            if (rateCheckIn !== storedCheckIn || rateCheckOut !== storedCheckOut) {
                Swal.fire({
                    title: "Date Mismatch!",
                    text: "The selected dates do not match the rate dates. Please try searching again.",
                    icon: "warning",
                    draggable: true,
                });
                return;
            }

            const calculatedPrice = await getPrice(rate.net, userData.token);
            
            const params = new URLSearchParams();
            params.set('checkIn', storedCheckIn);
            params.set('checkOut', storedCheckOut);
            params.set('rooms', formParams.rooms.map(room => room.rooms).join(','));
            params.set('adults', formParams.rooms.map(room => room.adultCounter).join(','));
            params.set('children', formParams.rooms.map(room => room.childCounter).join(','));
            params.set('ages', formParams.rooms.map(room => 
                room.childrenAges.map(child => child.age).join('-')
            ).join('|'));
            params.set('nationality', formParams.nation || 'TR');

            navigate(`/checkout?${params.toString()}`, {
                state: {
                    hotel: {
                        ...hotel,
                        rooms: [{
                            ...room,
                            rates: [{
                                ...rate,
                                calculatedPrice
                            }]
                        }]
                    }
                }
            });
            window.scrollTo(0, 0);
        } catch (error) {
            console.error('Error in handleBookSubmit:', error);
            Swal.fire({
                title: "Error",
                text: "Failed to process booking. Please try again.",
                icon: "error",
                draggable: true,
            });
        }
    };

    // Daha fazla otel yükleme fonksiyonu
    const fetchMoreHotels = async (currentCounter) => {
        console.log("Daha fazla otel yükleniyor, sayaç:", currentCounter);
        try {
            const start = 10 + (currentCounter - 1) * step;
            const end = start + step;
            
            const selectedCodes = hotelCodes.slice(start, end);

            if (selectedCodes.length === 0) {
                console.warn("Yüklenecek başka otel kodu yok.");
                setMoreButtonStatu(false);
                return;
            }

            for (const code of selectedCodes) {
                if (loadedHotels.includes(code) || loadingHotels[code]) {
                    continue;
                }
                
                await loadSmallData(code);
                await new Promise(resolve => setTimeout(resolve, 100));
            }

            setMoreButtonStatu(end < hotelCodes.length);
        } catch (error) {
            console.error("Veri çekerken bir hata oluştu:", error);
        } finally {
            setMoreStatu(false);
        }
    };

    // "See More Hotels" butonuna tıklandığında çalışacak fonksiyon
    const handleLoadMore = () => {
        console.log("Load more tıklandı");
        if (moreCounter < Math.ceil(hotelCodes.length / step)) {
            setMoreStatu(true);
            setMoreCounter((prevCounter) => {
                const newCounter = prevCounter + 1;
                console.log("Yeni Sayaç:", newCounter);
                fetchMoreHotels(newCounter);
                return newCounter;
            });
        } else {
            console.log("Tüm oteller yüklendi");
        }
    };

    const updateRoomCount = (counterType) => {
        setFormParams((prevRooms) => {
            if (counterType === "increment") {
                return [
                    ...prevRooms,
                    {
                        id: prevRooms.length + 1,
                        adultCounter: 2,
                        childCounter: 0,
                        childrenAges: [],
                    },
                ];
            } else if (counterType === "decrement" && prevRooms.length > 1) {
                return prevRooms.slice(0, -1);
            }
            return prevRooms;
        });
    };

    const updateRoomCounters = (roomId, type, counterType) => {
        setFormParams((prevRooms) =>
            prevRooms.map((room) => {
                if (room.id === roomId) {
                    if (type === "adult") {
                        return {
                            ...room,
                            adultCounter:
                                counterType === "increment"
                                    ? room.adultCounter + 1
                                    : Math.max(1, room.adultCounter - 1),
                        };
                    } else if (type === "child") {
                        const newChildCounter =
                            counterType === "increment"
                                ? room.childCounter + 1
                                : Math.max(0, room.childCounter - 1);

                        const validChildCounter = Math.max(0, newChildCounter);

                        return {
                            ...room,
                            childCounter: validChildCounter,
                            childrenAges: validChildCounter < room.childrenAges.length
                                ? room.childrenAges.slice(0, validChildCounter)
                                : [
                                    ...room.childrenAges,
                                    ...Array(validChildCounter - room.childrenAges.length).fill({ type: 'CH', age: "" }),
                                ],
                        };
                    }
                }
                return room;
            })
        );
    };

    const handleChange = (values) => {
        if (values.length > 0) {
            setFormParams(prev => ({
                ...prev,
                nation: values[0].iso2
            }));
            localStorage.setItem("nation", values[0].iso2);
        } else {
            setFormParams(prev => ({
                ...prev,
                nation: ""
            }));
            localStorage.removeItem("nation");
        }
    };

    const handleChildAgeChange = (roomId, index, value) => {
        setFormParams((prevRooms) =>
            prevRooms.map((room) => {
                if (room.id === roomId) {
                    const updatedAges = [...room.childrenAges];
                    updatedAges[index] = { age: Number(value) };
                    return { ...room, childrenAges: updatedAges };
                }
                return room;
            })
        );
    };

    const handlePlaceSelected = (place) => {
        setSelectedPlace({
            name: place.name,
            lat: place.lat,
            lng: place.lng,
        });
        localStorage.setItem("place_name", place.name);
        localStorage.setItem("lat", place.lat);
        localStorage.setItem("lng", place.lng);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                setError(null);

                // URL parametrelerini al
                const checkIn = searchParams.get('checkIn');
                const checkOut = searchParams.get('checkOut');
                const nation = searchParams.get('nation');
                const lat = searchParams.get('lat');
                const lng = searchParams.get('lng');
                const locationName = searchParams.get('locationName');
                const occupanciesStr = searchParams.get('occupancies');

                // Eğer gerekli parametreler eksikse hata fırlat
                if (!checkIn || !checkOut || !nation || !lat || !lng || !locationName || !occupanciesStr) {
                    throw new Error('Missing required search parameters');
                }

                // Occupancies verisini parse et
                const occupancies = JSON.parse(decodeURIComponent(occupanciesStr));

                // Form parametrelerini güncelle
                setFormParams({
                    checkIn,
                    checkOut,
                    nation,
                    lat,
                    lng,
                    locationName,
                    occupanciesStr,
                    rooms: occupancies.map((room, index) => ({
                        id: index + 1,
                        adultCounter: room.adults,
                        childCounter: room.children,
                        childrenAges: room.paxes || []
                    }))
                });

                // Otel verilerini getir
                const requestParams = {
                    stay: {
                        checkIn,
                        checkOut
                    },
                    geolocation: {
                        latitude: lat,
                        longitude: lng,
                        radius: 3,
                        unit: "km"
                    },
                    language: "ENG",
                    sourceMarket: nation,
                    occupancies,
                    filters: {
                        minPrice: 100,
                        maxPrice: 5000,
                        maxRooms: 10,
                        maxRatesPerRoom: 5
                    }
                };

                const response = await hotelService.getHotels(requestParams);
                
                if (response && Array.isArray(response)) {
                    setDetailedHotels(response);
                    setFirstHotel(response.length > 0 ? [response[0]] : null);
                    setHotelCodes(response.map(hotel => hotel.code));
                    setSortedHotels(response);
                } else {
                    throw new Error('Invalid response format from hotel service');
                }
        } catch (error) {
                console.error('Error fetching data:', error);
                setError(error.message);
        } finally {
                setIsLoading(false);
        }
    };

        fetchData();
    }, [searchParams]); // searchParams değiştiğinde useEffect'i tekrar çalıştır

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const scrollHeight = document.documentElement.scrollHeight;
            const windowHeight = window.innerHeight;
            
            if (scrollY >= 330 && scrollY <= scrollHeight - windowHeight - 450) {
                setIsFixed(true);
                setHeight(`${windowHeight}px`);
            } else {
                setIsFixed(false);
                setHeight('95%');
            }
        };
    
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const getIcon = (type) => {
        if (type === "locality") return <FaMapMarkerAlt />;
        if (type === "hotel") return <FaHotel />;
        if (type === "lodging") return <FaBed />;
        if (type === "airport") return <MdOutlineLocalAirport />;
        return <FaMapMarkerAlt />;
    };

    const handleSubmitForm = async (e) => {
        e.preventDefault();

        if (!selectedPlace) {
            Swal.fire({
                title: "Please select the destination!",
                icon: "info",
                draggable: true,
            });
            return;
        }

        if(!formParams.nation) {
            Swal.fire({
                title: "Please select the nationality!",
                icon: "info",
                draggable: true,
            });
            return;
        }

        const params = new URLSearchParams();
        
        params.set('checkIn', formParams.checkIn);
        params.set('checkOut', formParams.checkOut);
        params.set('nation', localStorage.getItem("nation") ?? "TR");
        params.set('lat', selectedPlace ? selectedPlace.lat : localStorage.getItem("lat"));
        params.set('lng', selectedPlace ? selectedPlace.lng : localStorage.getItem("lng"));
        
        if (selectedLocation.hotelbeds_code) {
            params.set('hotelbedsCode', selectedLocation.hotelbeds_code);
        }
        params.set('locationName', selectedLocation.name || selectedPlace.name);

        const occupancies = formParams.rooms.map(room => ({
            rooms: 1,
            adults: room.adultCounter,
            children: room.childCounter,
            paxes: room.childrenAges.map(child => ({
                type: "CH",
                age: child.age || ""
            }))
        }));
        params.set('occupancies', JSON.stringify(occupancies));

        navigate(`/hotels-with-map?${params.toString()}`);
        window.scrollTo(0, 0);

        if(selectedLocation.hotelbeds_code) {
            await fetchFirstHotel();
        }
        await fetchHotels(hotelFetchParams);
    };

    const handleViewHotels = () => {
        const params = new URLSearchParams();
        
        params.set('checkIn', formParams.checkIn);
        params.set('checkOut', formParams.checkOut);
        params.set('nation', localStorage.getItem("nation") ?? "TR");
        params.set('lat', localStorage.getItem('lat'));
        params.set('lng', localStorage.getItem('lng'));
        
        if (selectedLocation.hotelbeds_code) {
            params.set('hotelbedsCode', selectedLocation.hotelbeds_code);
        }
        params.set('locationName', selectedLocation.name || selectedPlace?.name || localStorage.getItem("place_name"));

        const occupancies = formParams.rooms.map(room => ({
            rooms: 1,
            adults: room.adultCounter,
            children: room.childCounter,
            paxes: room.childrenAges.map(child => ({
                type: "CH",
                age: child.age || ""
            }))
        }));
        params.set('occupancies', JSON.stringify(occupancies));

        navigate(`/hotels-with-map?${params.toString()}`);
        window.scrollTo(0, 0); 
        
        fetchHotels(hotelFetchParams);
    };

    const fetchSuggestions = async (searchText) => {
        setIsSuggestLoading(true);
        try {
            const response = await axios.get(
                `${config.API_BASE_URL_V1}auto-complete?search=${searchText}`,
                {
                    headers: {
                        Authorization: `Bearer ${userData.token}`,
                    },
                }
            );
            setSuggestions(response.data.data.slice(0, 10));
        } catch (error) {
            console.error("Error fetching suggestions:", error);
            setSuggestions([]);
        } finally {
            setIsSuggestLoading(false);
        }
    };

    const handleSuggestInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
    
        if (value.length < 3) {
            setSuggestions([]);
                return;
            }
    
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }
    
        debounceTimeout.current = setTimeout(() => {
            fetchSuggestions(value);
        }, 1000);
    };

    const handleSuggestionClick = (suggestion) => {
        setSelectedLocation({
            name: suggestion.name,
            latitude: suggestion.latitude,
            longitude: suggestion.longitude,
            hotelbeds_code: suggestion.hotelbeds_code || "",
            formatted_address: suggestion.formatted_address || "",
        });
        setSelectedPlace({
            name: suggestion.name,
            lat: suggestion.latitude,
            lng: suggestion.longitude,
        });
        localStorage.setItem("place_name", suggestion.name);
        localStorage.setItem("lat", suggestion.latitude);
        localStorage.setItem("lng", suggestion.longitude);
        setInputValue(suggestion.name);
        setSuggestions([]);
    };

    const getMarkers = (Hotels) => {
        // Sadece ilk 10 oteli al
        const firstTenHotels = Hotels.slice(0, 10);
        return firstTenHotels.map((hotel, index) => ({
            id: index + 1,
            lat: hotel.latitude || hotel.coordinates?.latitude || 0,
            lng: hotel.longitude || hotel.coordinates?.longitude || 0,
            grid_name: hotel.name || '',
            grid_address: `${hotel.country?.description?.content || ''} - ${hotel.city?.content || ''}`,
            grid_rate: `${hotel.minRate || 0} - ${hotel.maxRate || 0} ${hotel.currency || 'USD'}`,
            grid_day: "Night",
            grid_star: hotel.star || 0,
            hotel: hotel,
            image: hotel.images?.[0]?.path || "https://via.placeholder.com/150",
        }));
    };

    const currentMarkers = getMarkers(detailedHotels);

    const GoogleMap = () => {
        const [center, setCenter] = useState({
            lat: currentMarkers[0]?.lat,
            lng: currentMarkers[0]?.lng,
        });

        useEffect(() => {
            const map = new window.google.maps.Map(document.getElementById("map"), {
                center: { lat: currentMarkers?.[0]?.lat, lng: currentMarkers?.[0]?.lng },
                zoom: 15,
            });
    
            let openInfoWindow = null;
    
            currentMarkers.forEach((marker) => {
                const googleMarker = new window.google.maps.Marker({
                    position: { lat: marker.lat, lng: marker.lng },
                    map: map,
                    title: marker.grid_name,
                });
    
                const infoWindow = new window.google.maps.InfoWindow();
                googleMarker.addListener("click", () => {
                    if (openInfoWindow) {
                        openInfoWindow.close();
                    }
    
                    const contentDiv = document.createElement("div");
                    ReactDOM.render(
                        <div className="card">
                            <div className="card-img">
                                <img
                                    className="img-fluid w-100"
                                    style={{ height: "150px", objectFit: "cover" }}
                                    alt="img"
                                    src={marker.image}
                                />
                            </div>
                            <div className="card-body">
                                <h5 className="title mb-2">
                                    <a
                                        onClick={() => handleViewDetails(marker.hotel)}
                                    >
                                        {marker.grid_name}
                                    </a>
                                </h5>
                                <p className="mb-3">
                                    <i className="isax isax-location"></i> {marker.grid_address}
                                </p>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <h6 className="text-primary border-end pe-2 me-2">
                                            {marker.grid_rate}
                                        </h6>
                                        <p>{marker.grid_day}</p>
                                    </div>
                                </div>
                            </div>
                        </div>,
                        contentDiv
                    );
    
                    infoWindow.setContent(contentDiv);
                    infoWindow.open(map, googleMarker);
                    openInfoWindow = infoWindow;
                });
            });

            map.addListener("center_changed", () => {
                const newCenter = map.getCenter();
                setCenter({
                    lat: newCenter.lat(),
                    lng: newCenter.lng(),
                });
                localStorage.setItem('lat', newCenter.lat());
                localStorage.setItem('lng', newCenter.lng());
            });
    
            map.addListener("click", () => {
                if (openInfoWindow) {
                    openInfoWindow.close();
                    openInfoWindow = null;
                }
            });
        }, []);
    
        return <div id="map" style={{ height: "100%", width: "100%" }} />;
    };

    const fetchFirstHotel = async (code) => {
        try {
            setIsLoading(true);
            const requestParams = {
                stay: {
                    checkIn: formParams.checkIn,
                    checkOut: formParams.checkOut
                },
                occupancies: formParams.rooms.map(room => ({
            rooms: 1,
            adults: room.adultCounter,
            children: room.childCounter,
            paxes: room.childrenAges.map(child => ({
                type: "CH",
                age: child.age || ""
            }))
                })),
                language: "ENG",
                sourceMarket: formParams.nation ?? "ENG"
            };

            const smallData = await hotelService.getSmallData([code], requestParams);
            
            if (smallData && smallData.length > 0) {
                const hotelData = smallData[0];
                setFirstHotel([{
                    ...hotelData,
                    isLoading: false
                }]);
            }
        } catch (error) {
            console.error('Error fetching first hotel:', error);
        } finally {
            setIsLoading(false);
        }
    };

    if (error) {
        return (
            <Layout>
                <div className="alert alert-danger m-3">
                    <p>{error}</p>
                    <button className="btn btn-outline-danger" onClick={() => window.location.reload()}>
                        Retry
                    </button>
                </div>
            </Layout>
        );
    }

    if(isLoading) {
        return (
        <div id="loader-wrapper">
            <div id="loader">
                <span className="loader-line"></span>
            </div>
        </div>
        );
    }

  return (
    <Layout>
        <div className="breadcrumb-bar breadcrumb-bg-01 text-center">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-12">
                        <h2 className="breadcrumb-title mb-2">Hotels</h2>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb justify-content-center mb-0">
                                <li className="breadcrumb-item"><a href="index.html"><i className="isax isax-home5"></i></a></li>
                                <li className="breadcrumb-item">Hotels</li>
                                <li className="breadcrumb-item active" aria-current="page">Hotel Lists</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <div className="content pb-0 container">
            <div className="">
                <div className="card">
                    <div className="card-body">
                        <div className="banner-form">
                        <form onSubmit={handleSubmitForm}>
                            <div className="d-lg-flex">
                                <div className="d-flex form-info">
                                    <div className="form-item dropdown">
                                        <div>
                                            <label className="form-label fs-14 text-default mb-3">
                                                Destination & Hotel
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="Enter a place name"
                                                value={inputValue ?? localStorage.getItem('place_name')}
                                                onChange={handleSuggestInputChange}
                                                className="form-control"
                                            />
                                            {isSuggestLoading && <div>Loading...</div>}
                                                {suggestions.length > 0 && (
                                                    <ul style={{ width: "300px" }} className="dropdown-menu-custom">
                                                        {suggestions.map((suggestion, index) => (
                                                            <li
                                                                key={index}
                                                                onClick={() => handleSuggestionClick(suggestion)}
                                                                className="dropdown-item-custom"
                                                            >
                                                                {getIcon(suggestion.type)} {suggestion.name}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                        </div>
                                    </div>
                                    <div className="form-item d-flex flex-column">
                                        <label className="form-label fs-14 text-default mb-3">Check In</label>
                                        <input 
                                            type="date" 
                                            className="form-control"
                                            min={new Date().toISOString().split('T')[0]}
                                                    value={formParams.checkIn}
                                            onChange={(e) => {
                                                const newStartDate = e.target.value;
                                                        setFormParams(prev => ({
                                                            ...prev,
                                                            checkIn: newStartDate
                                                        }));
                                                const nextDay = new Date(newStartDate);
                                                nextDay.setDate(nextDay.getDate() + 1);
                                                        setFormParams(prev => ({
                                                            ...prev,
                                                            checkOut: nextDay.toISOString().split('T')[0]
                                                        }));
                                            }}
                                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                        />
                                    </div>
                                    <div className="form-item">
                                        <label className="form-label fs-14 text-default mb-3">Check Out</label>
                                        <input 
                                            type="date"
                                            className="form-control"
                                                    value={formParams.checkOut}
                                                    min={formParams.checkIn} 
                                                    max={formParams.checkIn ? new Date(new Date(formParams.checkIn).setDate(new Date(formParams.checkIn).getDate() + 90)).toISOString().split('T')[0] : ''} 
                                                    onChange={(e) => setFormParams(prev => ({
                                                        ...prev,
                                                        checkOut: e.target.value
                                                    }))} 
                                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                        />
                                    </div>
                                    <div className="form-item dropdown">
                                        <div>
                                            <label className="form-label fs-14 text-default mb-1">Guests</label>
                                            <h5>
                                                        {formParams.rooms?.reduce((total, room) => total + room.adultCounter + room.childCounter, 0)} 
                                                <span className="fw-normal fs-14"> Persons</span>
                                            </h5>

                                            <p
                                                onClick={() => setPersonalModal(!personalModal)}
                                                style={{ cursor: "pointer", padding: "1%", color: "gray" }}
                                            >
                                                        {formParams.rooms?.length} Room,{" "}
                                                        {formParams.rooms?.reduce((total, room) => total + room.adultCounter, 0)} Adult,{" "}
                                                        {formParams.rooms?.reduce((total, room) => total + room.childCounter, 0)} Children
                                                    </p>
                                        </div>
                                        <div
                                            className="personality"
                                            ref={counterRef}
                                            style={{
                                                display: personalModal ? "block" : "none",
                                                width: "350px",
                                                backgroundColor: "whitesmoke",
                                                padding: "10px",
                                                borderRadius: "4px",
                                                border: "solid 1px lightgray",
                                                position: "absolute",
                                                        zIndex: 9999,
                                                marginLeft: "-100px",
                                                        top: "100%",
                                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                            }}
                                        >
                                            <div className="d-flex flex-row" style={{ gap: "10px", paddingBlock: "20px" }}>
                                                <div className="d-flex flex-row" style={{ gap: "10px", justifyContent: "space-between" }}>
                                                    <label htmlFor="">Room:</label>
                                                    <div className="d-flex flex-row">
                                                        <button
                                                            type="button"
                                                            onClick={() => updateRoomCount("decrement")}
                                                            style={{
                                                                cursor: "pointer",
                                                                border: "solid 1px lightgray",
                                                                width: "25px",
                                                                height: "25px",
                                                                textAlign: "center",
                                                                fontWeight: "bold",
                                                                alignSelf: "center",
                                                            }}
                                                        >
                                                            -
                                                        </button>
                                                        <span
                                                            className='bg-white'
                                                            style={{
                                                                border: "solid 1px lightgray",
                                                                width: "50px",
                                                                textAlign: "center",
                                                                fontWeight: "bold",
                                                                alignSelf: "center",
                                                            }}
                                                        >
                                                                    {formParams.rooms?.length}
                                                        </span>
                                                        <button
                                                            type="button"
                                                            onClick={() => updateRoomCount("increment")}
                                                            style={{
                                                                cursor: "pointer",
                                                                border: "solid 1px lightgray",
                                                                width: "25px",
                                                                height: "25px",
                                                                textAlign: "center",
                                                                fontWeight: "bold",
                                                                alignSelf: "center",
                                                            }}
                                                        >
                                                            +
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex flex-column">
                                                        {formParams.rooms.map((room) => (
                                                    <div
                                                        key={room.id}
                                                        className="d-flex flex-row bg-white"
                                                        style={{
                                                            border: "solid 1px lightgray",
                                                            padding: "10px",
                                                            width: "100%",
                                                            marginBottom: "20px",
                                                        }}
                                                    >
                                                        <div
                                                            className="d-flex flex-row"
                                                            style={{ justifyContent: "space-between", width: "100%", gap:'3px' }}
                                                        >
                                                            <div
                                                                className="d-flex flex-column"
                                                                style={{ textAlign: "center" }}
                                                            >
                                                                <label htmlFor="">Adult</label>
                                                                <div
                                                                    className="d-flex flex-row"
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        onClick={() =>
                                                                            updateRoomCounters(
                                                                                room.id,
                                                                                "adult",
                                                                                "decrement"
                                                                            )
                                                                        }
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            border: "solid 1px lightgray",
                                                                            width: "25px",
                                                                            height: "25px",
                                                                            textAlign: "center",
                                                                            fontWeight: "bold",
                                                                            alignSelf: "center",
                                                                        }}
                                                                    >
                                                                        -
                                                                    </button>
                                                                    <span
                                                                        style={{
                                                                            border: "solid 1px lightgray",
                                                                            width: "50px",
                                                                            textAlign: "center",
                                                                            fontWeight: "bold",
                                                                            alignSelf: "center",
                                                                        }}
                                                                    >
                                                                        {room.adultCounter}
                                                                    </span>
                                                                    <button
                                                                        type="button"
                                                                        onClick={() =>
                                                                            updateRoomCounters(
                                                                                room.id,
                                                                                "adult",
                                                                                "increment"
                                                                            )
                                                                        }
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            border: "solid 1px lightgray",
                                                                            width: "25px",
                                                                            height: "25px",
                                                                            textAlign: "center",
                                                                            fontWeight: "bold",
                                                                            alignSelf: "center",
                                                                        }}
                                                                    >
                                                                        +
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="d-flex flex-column"
                                                                style={{
                                                                    textAlign: "center",
                                                                    marginRight: "30px",
                                                                }}
                                                            >
                                                                <label htmlFor="">Children</label>
                                                                <div
                                                                    className="d-flex flex-row"
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        onClick={() =>
                                                                            updateRoomCounters(
                                                                                room.id,
                                                                                "child",
                                                                                "decrement"
                                                                            )
                                                                        }
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            border: "solid 1px lightgray",
                                                                            width: "25px",
                                                                            height: "25px",
                                                                            textAlign: "center",
                                                                            fontWeight: "bold",
                                                                            alignSelf: "center",
                                                                        }}
                                                                    >
                                                                        -
                                                                    </button>
                                                                    <span
                                                                        style={{
                                                                            border: "solid 1px lightgray",
                                                                            width: "50px",
                                                                            textAlign: "center",
                                                                            fontWeight: "bold",
                                                                            alignSelf: "center",
                                                                        }}
                                                                    >
                                                                        {room.childCounter}
                                                                    </span>
                                                                    <button
                                                                        type="button"
                                                                        onClick={() =>
                                                                            updateRoomCounters(
                                                                                room.id,
                                                                                "child",
                                                                                "increment"
                                                                            )
                                                                        }
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            border: "solid 1px lightgray",
                                                                            width: "25px",
                                                                            height: "25px",
                                                                            textAlign: "center",
                                                                            fontWeight: "bold",
                                                                            alignSelf: "center",
                                                                        }}
                                                                    >
                                                                        +
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="d-flex flex-column"
                                                            style={{ width: "30%", gap: "10px" }}
                                                        >
                                                            {room.childrenAges.map((child, index) => (
                                                                <div
                                                                    className="d-flex flex-column"
                                                                    style={{ margin: "auto" }}
                                                                    key={index}
                                                                >
                                                                    <label>{index + 1} Age:</label>
                                                                    <input
                                                                        type="number"
                                                                        value={child.age || ""}
                                                                        style={{
                                                                            width: "50px",
                                                                            border: "solid 1px lightgray",
                                                                            padding: "1%",
                                                                            borderRadius: "10px",
                                                                        }}
                                                                        name="children_age[]"
                                                                        required
                                                                        onChange={(e) =>
                                                                            handleChildAgeChange(
                                                                                room.id,
                                                                                index,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-item dropdown">
                                        <label className="form-label fs-14 text-default mb-3">Nationality</label>
                                        <Select
                                                    options={countries}
                                                    values={formParams.nation ? [{ name: formParams.nation }] : []} 
                                                    onChange={handleChange}
                                                    valueField="name"
                                                    labelField="name"
                                                    searchable={true}
                                                    placeholder="Select nation"
                                                    dropdownHeight="200px"
                                                    closeOnSelect={true}
                                                    multi={false}
                                            className="custom-dropdown"
                                            style={{ borderRadius:'10px', borderColor:'whitesmoke' }}
                                        />
                                    </div>
                                </div>
                                <button type="submit"
                                    className="btn btn-dark search-btn rounded">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
                <div className="row">
                    <div className="col-xl-8">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <p className="mb-3"> <a href="/hotels" style={{ color:'blue' }}>Click </a>for list view.</p>
                    <div className="d-flex align-items-center flex-wrap">
                        <div className="dropdown mb-3">
                            <a href="javascript:void(0);" className="dropdown-toggle py-2" data-bs-toggle="dropdown" aria-expanded="false">
                                        <span className="fw-medium text-gray-9">Sort By : </span>{selectedOption}
                            </a>
                            <div className="dropdown-menu dropdown-sm">
                                <h6 className="fw-medium fs-16 mb-3">Sort By</h6>
                                <div className="form-check d-flex align-items-center ps-0 mb-2">
                                    <input 
                                        className="form-check-input ms-0 mt-0" 
                                        name="recommend" 
                                        type="checkbox" 
                                        id="recommend" 
                                                checked={selectedOption === 'recommend'} 
                                                onChange={() => setSelectedOption('recommend')}
                                    />
                                    <label className="form-check-label ms-2" htmlFor="recommend">Recommended</label>
                                </div>
                                <div className="form-check d-flex align-items-center ps-0 mb-2">
                                    <input 
                                        className="form-check-input ms-0 mt-0" 
                                        name="recommend" 
                                        type="checkbox" 
                                        id="price_asc" 
                                                checked={selectedOption === 'price_asc'} 
                                                onChange={() => setSelectedOption('price_asc')}
                                    />
                                    <label className="form-check-label ms-2" htmlFor="price_asc">Price: low to high</label>
                                </div>
                                <div className="form-check d-flex align-items-center ps-0 mb-2">
                                    <input 
                                        className="form-check-input ms-0 mt-0" 
                                        name="recommend" 
                                        type="checkbox" 
                                        id="price_desc" 
                                                checked={selectedOption === 'price_desc'} 
                                                onChange={() => setSelectedOption('price_desc')}
                                    />
                                    <label className="form-check-label ms-2" htmlFor="price_desc">Price: high to low</label>
                                </div>
                                <div className="form-check d-flex align-items-center ps-0 mb-2">
                                    <input 
                                        className="form-check-input ms-0 mt-0" 
                                        name="recommend" 
                                        type="checkbox" 
                                        id="name_asc" 
                                                checked={selectedOption === 'name_asc'} 
                                                onChange={() => setSelectedOption('name_asc')}
                                    />
                                    <label className="form-check-label ms-2" htmlFor="name_asc">Name A-Z</label>
                                </div>
                                <div className="form-check d-flex align-items-center ps-0 mb-2">
                                    <input 
                                        className="form-check-input ms-0 mt-0" 
                                        name="recommend" 
                                        type="checkbox" 
                                        id="name_desc" 
                                                checked={selectedOption === 'name_desc'} 
                                                onChange={() => setSelectedOption('name_desc')}
                                    />
                                    <label className="form-check-label ms-2" htmlFor="name_desc">Name Z-A</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div> 
                            <div className="hotel-list">
                                <div className="row justify-content-center">
                            <div className="col-md-12">
                                        {firstHotel?.[0] != null && 
                                    <ListCard
                                        isFirstHotel={true}
                                        hotel={firstHotel?.[0]}
                                        handleViewDetails={handleViewDetails}
                                        handleBookSubmit={handleBookSubmit}
                                        setSelectedRate={setSelectedRate}
                                        markupValue={markupValue}
                                    />
                                }
                                        {detailedHotels.length > 0 ? (
                                        <>
                                                {detailedHotels.map((hotel, index) => {
                                                if (firstHotel?.[0]?.code === hotel.code) {
                                                    return null;
                                                }

                                                return (
                                                        <ListCard
                                                            key={hotel.code}
                                                            index={index}
                                                            hotel={hotel}
                                                            handleViewDetails={handleViewDetails}
                                                            handleBookSubmit={handleBookSubmit}
                                                            setSelectedRate={setSelectedRate}
                                                            markupValue={markupValue}
                                                        />
                                                );
                                            })}

                                            {moreStatu ? (
                                                <div className="d-flex">
                                                    <p style={{ margin: 'auto' }}>Loading data, please wait...</p>
                                                </div>
                                            ) : moreButtonStatu ? (
                                                <div className="d-flex">
                                                    <button
                                                        type="button"
                                                        style={{ margin: 'auto' }}
                                                        className="btn btn-primary"
                                                        onClick={handleLoadMore}
                                                        disabled={moreStatu}
                                                    >
                                                        Show more hotels
                                                    </button>
                                                </div>
                                            ) : null}
                                        </>
                                    ) : (
                                            <div className="flex items-center justify-content-center" style={{ marginBlock: '100px' }}>
                                            <p className="text-center">No data in hotels</p>
                                        </div>
                                        )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

                    {detailedHotels.length > 0 ? (
                <div className="col-xl-4">
                    <div 
                        style={isFixed 
                            ? { 
                                width: '450px', 
                                height, 
                                position: 'fixed', 
                                marginTop: '-25%', 
                                paddingBottom: '50px' 
                            } 
                            : { 
                                width: '100%', 
                                height, 
                                position: 'relative' 
                            }}
                    >
                        {!isFixed && (
                            <button
                                style={{
                                            position: "absolute",
                                            top: "50px",
                                    left: "50%",
                                    transform: "translateX(-50%)", 
                                    padding: "10px 20px",
                                    fontSize: "16px",
                                    backgroundColor: "#007bff",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "5px",
                                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                    cursor: "pointer",
                                            zIndex: 1000,
                                }}
                                onClick={() => handleViewHotels()}
                            >
                                View Hotels
                            </button>
                        )}
                        <GoogleMapsLoader apiKey={apiKey}>
                            <GoogleMap />
                        </GoogleMapsLoader>
                        {isFixed && (
                            <button
                                style={{
                                            position: "absolute",
                                    top: "50px", 
                                    left: "50%",
                                    transform: "translateX(-50%)", 
                                    padding: "10px 20px",
                                    fontSize: "16px",
                                    backgroundColor: "#007bff",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "5px",
                                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                    cursor: "pointer",
                                            zIndex: 1000,
                                }}
                                onClick={() => handleViewHotels()}
                            >
                                View Hotels
                            </button>
                        )}
                    </div>
                </div>
                    ) : null}
        </div>
    </div>

    <Modal 
        show={selectedRate !== null} 
        onHide={() => setSelectedRate(null)} 
        centered
                backdropClassName="custom-backdrop"
    >
        <Modal.Header closeButton>
            <Modal.Title>Cancellation Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {selectedRate?.cancellationPolicies?.map((policy, index) => (
                <div key={index} className="d-flex flex-column" style={{ minWidth: "200px" }}>
                    <p
                        className="d-inline-flex align-items-center mb-2 me-2 gap-1"
                        style={{ color: "black", textAlign: "center", fontSize: "13px" }}
                    >
                        <FaInfoCircle className="me-1" style={{ color: "red" }} />
                        <span>You can cancel until </span>
                        <span style={{ color: "red" }}>
                            {new Intl.DateTimeFormat("en-US", {
                                dateStyle: "medium",
                                timeStyle: "short",
                            }).format(new Date(policy.from))}
                        </span>
                        <span> for </span>
                        <span style={{ color: "red" }}>
                            ${Number(policy.amount).toFixed(2)}
                        </span>
                    </p>
                </div>
            ))}
        </Modal.Body>

        <Modal.Footer>
            <Button variant="secondary" onClick={() => setSelectedRate(null)}>
                Close
            </Button>
        </Modal.Footer>
    </Modal>
    </Layout>
    );
}
